import { combineReducers } from '@reduxjs/toolkit';
import partnersReducer, {
  setPartners,
  setSelectedPartner,
  updatePartnerInList,
  removePartnerFromList,
  setFilters as setPartnerFilters,
  setPagination as setPartnerPagination,
  resetFilters as resetPartnerFilters,
  resetPartners,
} from './partnersSlice';
import clinicsReducer, {
  setClinics,
  setSelectedClinic,
  addClinicToList,
  updateClinicInList,
  removeClinicFromList,
  resetClinics,
} from './clinicsSlice';

const b2bReducer = combineReducers({
  partners: partnersReducer,
  clinics: clinicsReducer,
});

export default b2bReducer;

// Export partner actions with clear naming
export {
  setPartners,
  setSelectedPartner,
  updatePartnerInList,
  removePartnerFromList,
  setPartnerFilters,
  setPartnerPagination,
  resetPartnerFilters,
  resetPartners,
};

// Export clinic actions with clear naming
export {
  setClinics,
  setSelectedClinic,
  addClinicToList,
  updateClinicInList,
  removeClinicFromList,
  resetClinics,
};

// Export selectors
export * from './selectors';
